import type { Article } from '../../../shared/article-types.js';
import { getContent } from '../../../shared/content.js';
import { Blocks } from '../../components/RichText.js';
import { useHref, useLocale } from '../../i18n.js';
import { AdSlot } from '../AdSlot.js';
import { formatDate } from './Blog.js';

/**
 * One article.
 *
 * Carries an ad unit, below the whole piece: this is substantive publisher content, which
 * is precisely the case where the policy permits one. The article is found by slug before
 * this renders, so there is no not-found branch here.
 */

export function ArticlePage({ article }: { article: Article }) {
  const locale = useLocale();
  const c = getContent(locale).blog;
  const href = useHref();

  return (
    <>
      <section className="section">
        <div className="section__inner section__inner--narrow prose">
          <p className="article__meta">
            <a href={href('/blog')}>{c.heading}</a>
            <span aria-hidden="true"> · </span>
            <time dateTime={article.published}>
              {c.publishedPrefix} {formatDate(article.published, locale)}
            </time>
          </p>

          <h1 className="section__title">{article.heading}</h1>
          <p className="section__lede">{article.lede}</p>

          <Blocks blocks={article.blocks} />
        </div>
      </section>

      <AdSlot slot="article-footer" />
    </>
  );
}
